import { Icons, Images } from "assets";
import classNames from "classnames";
import CustomModal from "shared/components/common/customModal";
import styles from "./style.module.scss";
import { ProductType } from "shared/utils/enum";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface Props extends ModalProps {
  detail: ReportedProductDetail | null;
}

const ReportedProductDetailsModal = ({ detail, show, handleClose }: Props) => {
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={styles.modalTitle}>Report Details</h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              handleClose();
            }}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-2")}
        >
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Reason</h4>
            <p className="">{detail?.reason || "N/A"}</p>

            <h4>Description</h4>
            <p className="">{detail?.desc || "N/A"}</p>

            {detail?.image?.fullpath ? (
              <>
                <h4>Proof</h4>
                <div>
                  <img
                    src={detail?.image?.fullpath}
                    alt=""
                    style={{
                      height: "300px",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </>
            ) : null}
          </div>

          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Product</h4>
            <div className="flex items-center justify-center my-2">
              <Swiper
                className={classNames(styles.listingSlider)}
                spaceBetween={0}
                slidesPerView={1}
                loop
                pagination={{ type: "bullets", clickable: true }}
                modules={[Pagination]}
              >
                <div className={classNames(styles.productImgContainer)}>
                  {detail?.product?.media
                    ?.filter((media) => media.type !== "video")
                    ?.map((media, index) => (
                      <SwiperSlide key={index} className="slider-img relative">
                        <img
                          src={media.fullpath}
                          alt=""
                          height={120}
                          width={188}
                        />
                      </SwiperSlide>
                    ))}
                </div>
              </Swiper>
            </div>
            <p className="">
              <strong>Title:</strong> {detail?.product?.title || "N/A"}
            </p>
            <p className="">
              <strong>Price:</strong>{" "}
              {detail?.product?.product_type === ProductType.ISO
                ? `$${detail?.product?.price} - $${detail?.product?.priceUpto}`
                : `$${detail?.product?.price}` || "N/A"}
            </p>
            <p className="">
              <strong>Year:</strong> {detail?.product?.year || "N/A"}
            </p>
            <p className="">
              <strong>Make:</strong> {detail?.product?.make || "N/A"}
            </p>
            <p className="">
              <strong>Model:</strong> {detail?.product?.model || "N/A"}
            </p>
            <p className="">
              <strong>Description:</strong> {detail?.product?.desc || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Reported By</h4>
            <div className="flex items-center justify-center my-2">
              <div className={classNames(styles.imgContainer)}>
                <img
                  src={
                    detail?.reported_by?.profile_image?.fullpath
                      ? detail?.reported_by?.profile_image?.fullpath
                      : Images.DefaultAvatar
                  }
                  alt=""
                />
              </div>
            </div>
            <p className="">
              <strong>Name:</strong> {detail?.reported_by.name || "N/A"}
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default ReportedProductDetailsModal;
